import { render, staticRenderFns } from "./PaymentPlanDialog.vue?vue&type=template&id=0cb0668b&"
import script from "./PaymentPlanDialog.vue?vue&type=script&lang=ts&"
export * from "./PaymentPlanDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports